import "./billing-card.component.scoped.sass";
import React from "react";
import { BillingCardProps } from "src/types/billing-card-props";
import { useTranslation } from "react-i18next";
import Button from "@material-ui/core/Button/Button";
import { icons } from "src/statics/icons";
import { PaymentSectionInfoComponent } from "../payment-section-info/payment-section-info.component";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";

export const BillingCardComponent = (props: BillingCardProps) => {
  const { header, button, buttonAction, hint, title, subtitle, loading } = props;
  const [t] = useTranslation();
  const { infoIco, statsSmIco } = icons;
  return (
    <div className="card-wrapper">
      <div className="section-title">
        <PaymentSectionInfoComponent
          title={title}
          subTitle={subtitle}
        />
      </div>
      <div className="billing-card">
        {loading && <div className="loader">
          <CircularProgress />
        </div>}
        <div className="padded">
          <div className="header">
						<div className="text">{t(header)}</div>
					</div>
					<div className="content">{props.children}</div>
        </div>
        {!loading && (<div className="footer">
          {hint && (
            <div className="hint">
              <img src={infoIco} className="icon" alt="bill"/>
              <div className="text">* {t(hint)}</div>
            </div>
          )}
          {button && (
            <Button
              variant="contained"
              className="btn-tool btn-warning"
              onClick={buttonAction}
            >
              <img className="icon" src={statsSmIco} alt="bill"/>
              {t(button)}
            </Button>
          )}
          {!button && (
            <div  className="spacer" />
          )}
        </div> )}
      </div>
    </div>
  );
};
